import { ROOM_FLEXIBILITY_VALUES } from "@clockwise/client-commons/src/util/event-tag";
import { Select, SelectOption } from "@clockwise/design-system";
import React from "react";

type Props = {
  onChange: (allowRoomChange: boolean) => void;
  defaultAllowSimilarRooms: boolean;
  isDisabled: boolean;
};

export function AutopilotFormRoom({ onChange, defaultAllowSimilarRooms, isDisabled }: Props) {
  const onAllowRoomsChange = (value: string) => {
    onChange(value === ROOM_FLEXIBILITY_VALUES.FLEXIBLE);
  };
  return (
    <div className="cw-py-2 cw-w-full">
      <Select
        label="Meeting room flexibility"
        value={
          defaultAllowSimilarRooms
            ? ROOM_FLEXIBILITY_VALUES.FLEXIBLE
            : ROOM_FLEXIBILITY_VALUES.FIXED
        }
        onChange={onAllowRoomsChange}
        name="Meeting room flexibility"
        disabled={isDisabled}
        fullWidth
      >
        <SelectOption value={ROOM_FLEXIBILITY_VALUES.FIXED}>Keep original room</SelectOption>
        <SelectOption value={ROOM_FLEXIBILITY_VALUES.FLEXIBLE}>
          Ok to move to similar room
        </SelectOption>
      </Select>
    </div>
  );
}
